import { useQuery } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  GetTransferRequestListEntity,
} from 'services/openapi';
import { BidvTransferWithEvidenceQueryKeys } from './constants';
import { isEmpty } from 'lodash';

export type TransferRequestStatus =
  | 'ALL'
  | 'PENDING_APPROVAL'
  | 'PENDING_BIDV_SUBMIT'
  | 'PROCESSING'
  | 'COMPLETED'
  | 'FAILED'
  | 'SUBMIT_FAILED'
  | 'TIMEOUT'
  | 'REJECTED';

export type GetTransferRequestListVariables = {
  fromTime?: string;
  toTime?: string;
  status?: TransferRequestStatus;
  companyId?: string;
  phoneNumber?: string;
  page?: number;
  size?: number;
};

export const useGetTransferRequestListQuery = (
  variables: GetTransferRequestListVariables,
  enabled = true,
) => {
  const queryKey = [
    BidvTransferWithEvidenceQueryKeys.GET_TRANSFER_REQUEST_LIST,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetTransferRequestListEntity, Error>({
    queryKey,
    queryFn: () =>
      TransferWithEvidenceService.transferWithEvidenceControllerGetAllList(
        variables.fromTime,
        variables.toTime,
        variables.status,
        variables.companyId,
        variables.phoneNumber,
        variables.page,
        variables.size,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !isEmpty(variables), // Chỉ chạy query khi variables đã có giá trị
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
